import { FC } from 'react'
import { useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import {
  IconPaths,
  ModalSize,
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import { CoordenadorClienteModal } from '../../components/modal/CoordenadorClienteModal'
import { getEmpresaClienteById } from '../../../empresasCliente-list/core/_request'
import { RowActions, useModal, useToast } from '../../../../../../components'
import { deleteColaboradorCliente } from '../../core/_request'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { ColaboradorList } from '../../core/_models'

type Props = { coordenador: ColaboradorList }

export const CoordenadorActionsCell: FC<Props> = ({ coordenador }) => {
  const { refetch } = useQueryResponse()
  const { showModal } = useModal()
  const { showToast } = useToast()
  const [searchParams] = useSearchParams()
  const clienteId = Number(searchParams.get('cliente'))
  const nome = coordenador.nome || 'Coordenador'

  // A linha já tem o coordenador completo (vem do empregador): não precisa rebuscar a lista.
  const openEditModal = () =>
    showModal({
      title: 'Cadastro Coordenador',
      content: <CoordenadorClienteModal />,
      size: ModalSize.Medium,
      fetchers: {
        coordenador: async () => coordenador,
        cliente: () => getEmpresaClienteById(clienteId),
      },
    })

  // Excluir é destrutivo: confirmação com a consequência.
  const askDelete = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Excluir coordenador?',
      text: `${nome} deixará de ser coordenador deste empregador. Essa ação não pode ser desfeita.`,
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (!confirmed) return

    try {
      showAlertLoading()
      await deleteColaboradorCliente(clienteId, coordenador.id)
      Swal.close()
      showToast({ variant: 'success', title: `${nome} foi excluído.` })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  return (
    <RowActions
      itemName={nome}
      primaryAction={{ label: 'Alterar', onClick: openEditModal, icon: IconPaths.Pen }}
      items={[{ label: 'Excluir', onClick: askDelete, danger: true }]}
    />
  )
}
